export const UPDATE_HEADER_TITLE = 'UPDATE_HEADER_TITLE';
